<template>
    <div class="footer">
        <div class="footer__content">
            <div class="footer__logo">
                <img src="../../assets/logo_oniad/Oniad-logo-1tinta-claro.png" alt="">
            </div>
            <div class="footer__links">
                <router-link tag="a" :to="{name: 'home'}" >Home</router-link>
                <a href="#">Política de privacidad</a>
            </div>
            <div class="footer__contact">
                <div class="footer__contact__label"><h6>Contacto:</h6></div>
                <div class="footer__contact__addressess">
                    <div class="footer__contact__addressess__address">
                        <b>Oficina Europa:</b>
                        <span>Avenida del Rosario 8, Cuarte de Huerva, Zaragoza</span>
                        <a href="mailto:info@oniad.com" title="Email oniad: info@oniad.com">info@oniad.com</a>
                        <span>Llámanos: <a href="tel:+34919901955">(+34) 919 901 955</a> | <a href="tel:+34931939787">(+34) 931 939 787</a></span>
                    </div>

                    <div class="footer__contact__addressess__address">
                        <b>Oficina América:</b>
                        <span>811 Wilshire Boulevard, Los Angeles, California</span>
                        <a href="mailto:sales@oniad.com" title="Email oniad: sales@oniad.com">sales@oniad.com</a>
                        <span>Llámanos: <a href="tel:+12132610360">(+1) 213-261-0360</a> </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footerContent"
    }
</script>

<style lang="scss">
    .footer{
        grid-area: footer;
        width: 100%;
        display: flex;
        justify-content: center;
        background: #f8f9fa;
        z-index: 9;
        min-height: 200px;
        .footer__content{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
            padding: 1em 1em;
            max-width: 1500px;
            width: 100%;
            >div{
                margin: 1em;
            }
            .footer__logo{
                max-width: 175px;
            }
        }
    }
    .footer__links{
        display: flex;
        flex: 1 1 auto;
        a{
            margin: 1em;
        }
    }
    .footer__contact{
        display: flex;
        flex-direction: column;
        color: #666;

        .footer__contact__addressess {
            display: flex;
            flex-wrap: wrap;
            .footer__contact__addressess__address {
                display: flex;
                flex-direction: column;
                font-size: 0.8rem;
                margin: 1em;
            }
        }
    }
</style>